import { cn } from '../utils/cn';

interface FormActionsProps {
  onSave?: () => void;
  onSaveNew?: () => void;
  onReset?: () => void;
  onCancel?: () => void;
  saveLabel?: string;
  saveNewLabel?: string;
  resetLabel?: string;
  cancelLabel?: string;
  isSubmitting?: boolean;
  className?: string;
}

export default function FormActions({
  onSave, onSaveNew, onReset, onCancel,
  saveLabel = 'Save', saveNewLabel = 'Save & New', resetLabel = 'Reset', cancelLabel = 'Cancel',
  isSubmitting, className,
}: FormActionsProps) {
  return (
    <div className={cn('flex items-center justify-end gap-3 pt-4', className)}>
      {onCancel && (
        <button type="button" onClick={onCancel} className="rounded-lg border border-border px-4 py-2 text-sm font-medium text-content-secondary hover:bg-surface-card-hover transition-colors">
          {cancelLabel}
        </button>
      )}
      {onReset && (
        <button type="button" onClick={onReset} className="rounded-lg border border-border px-4 py-2 text-sm font-medium text-content-secondary hover:bg-surface-card-hover transition-colors">
          {resetLabel}
        </button>
      )}
      {onSaveNew && (
        <button type="button" onClick={onSaveNew} disabled={isSubmitting} className="rounded-lg border border-primary px-4 py-2 text-sm font-medium text-primary hover:bg-primary-light transition-colors disabled:opacity-50">
          {saveNewLabel}
        </button>
      )}
      {onSave && (
        <button type="submit" onClick={onSave} disabled={isSubmitting} className="rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary-hover transition-colors disabled:opacity-50">
          {isSubmitting ? 'Saving...' : saveLabel}
        </button>
      )}
    </div>
  );
}
